import { BID_STATUS } from "../utils/enums";
import SortDropdown from "./SortDropdown";

const OPTIONS = [
  { value: BID_STATUS.ALL, label: "All" },
  { value: BID_STATUS.WIN, label: "Win" },
  { value: BID_STATUS.ACTIVE, label: "Active" },
  { value: BID_STATUS.CLOSED, label: "Closed" },
  { value: BID_STATUS.PAID, label: "Paid" },
];

const BidStatusDropdown = ({ value, onChange }: any) => (
  <SortDropdown
    label="Status"
    icon="bi-funnel"
    options={OPTIONS}
    value={value || BID_STATUS.ALL}
    onChange={onChange}
  />
);

export default BidStatusDropdown;
